import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type Language = APIResponse<'/api/v4/languages'>[number];

export const fetchLanguages = () => get<Language[]>('/v4/languages');
